export enum documentType {
  Default = 0,
  DniNie = 1,
  Passport = 2,
}
